// @flow
import React from 'react';
import { ListFilterItem } from 'components/atoms/listFilterItem';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  options: Array,
  activeFilters: Array,
  toggleFilter: (option: any) => void,
};

export const GenreFilter = (props: Props) => {
  const { options, activeFilters = [], toggleFilter } = props;
  return (
    <div className={'genre-filters'}>
      <span className={'filter-type'}>GENRE</span>
      <div className={'filter-content-options'}>
        {options.map(genre => {
          return (
            <ListFilterItem
              key={genre.genreId}
              title={genre.genre}
              isActive={activeFilters.indexOf(genre.genreId) > -1}
              onClick={() => toggleFilter(genre)}
            />
          );
        })}
      </div>
    </div>
  );
};
